<span [formGroup]="form">
  <ng-container [ngSwitch]="swissField.controlType">
    <!-- Textbox  -->
    <ng-container *ngIf="swissField.options.key !== 'ObjPlz'">
	    <mat-form-field *ngSwitchCase="'textbox'" [style.margin]="ignoreStyling() ? '' : swissField!.options.styleMargin" [style.width]="ignoreStyling() ? '' : swissField!.options.styleWidth" class="no-padding" disabled>
        <mat-label>{{ swissField.options.label }}</mat-label>
		    <input [formControlName]="swissField.options.key!" [id]="swissField.options.key!" [type]="swissField.options.type" [value]="swissField.options.value" matInput>
      </mat-form-field>
    </ng-container>

    <ng-container *ngIf="swissField.options.key === 'ObjPlz'">
      <mat-form-field *ngSwitchCase="'textbox'" [style.margin]="ignoreStyling() ? '' : swissField!.options.styleMargin" [style.width]="ignoreStyling() ? '' : swissField!.options.styleWidth" class="no-padding">
        <mat-label>{{ swissField.options.label }}</mat-label>
	      <input (keyup)="onZIPChange($event)" [formControlName]="swissField.options.key!" [id]="swissField.options.key!"
                 [type]="swissField.options.type" [value]="swissField.options.value" matInput>
      </mat-form-field>
    </ng-container>

    <ng-container *ngIf="swissField.options.key === 'ObjectNumberRange'">
        <mat-form-field [style.margin]="ignoreStyling() ? '' : swissField!.options.styleMargin" [style.width]="ignoreStyling() ? '' : swissField!.options.styleWidth" class="no-padding mat-form-field">
            <object-number-range (valueChangedOutput)="setObjectNumberRange($event)" [objectType]="objectType$()"></object-number-range>
            <input matInput formControlName="ObjectNumberRange" readonly hidden>
        </mat-form-field>
    </ng-container>

      <!-- Datum mit Zeit -->
    <mat-form-field *ngSwitchCase="'date_with_time'" [style.margin]="ignoreStyling() ? '' : swissField!.options.styleMargin" [style.width]="ignoreStyling() ? '' : swissField!.options.styleWidth" class="no-padding">
      <mat-label>{{ swissField.options.label }}</mat-label>
	    <input [formControlName]="swissField.options.key!" [id]="swissField.options.key!" [type]="swissField.options.type"
               [value]="swissField.options.value" matInput>
    </mat-form-field>

      <!-- Datumsauswahl -->
    <mat-form-field *ngSwitchCase="'datepicker'" class="no-padding" [style]="ignoreStyling() ? '' : 'width: 49%; margin-right: 1%;'">
      <mat-label>{{ swissField.options.label }}</mat-label>
	    <input [formControlName]="swissField.options.key!" [id]="swissField.options.key!" [matDatepicker]="picker"
               [value]="swissField.options.value" matInput>
      <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

      <!-- Adresse zuweisen Icon -->
    <button (click)="addObjectAddress()" *ngSwitchCase="'adr_auswahl'" mat-icon-button style="margin: 0 0 0 0; width: 48px">
      <mat-icon>import_contacts</mat-icon>
    </button>

      <!-- Adressbox mit Adressenvorschau -->
    <app-address-form-field-container *ngSwitchCase="'adr_box_auswahl'" [style.margin]="ignoreStyling() ? '' : swissField!.options.styleMargin" [style.width]="ignoreStyling() ? '' : swissField!.options.styleWidth" [swissField]="swissField"
                                      class="no-padding address-form-field-container"></app-address-form-field-container>

      <!-- Dropdown -->
      <!-- For new Entities -->
    <ng-container *ngIf="swissField.isNewEntity">
      <mat-form-field *ngSwitchCase="'dropdown'" [style.margin]="ignoreStyling() ? '' : swissField!.options.styleMargin" [style.width]="ignoreStyling() ? '' : swissField!.options.styleWidth" class="no-padding">
        <mat-label>{{ swissField.options.label ? swissField.options.label : '' }}</mat-label>
	      <mat-select (selectionChange)="dropdownSelectionChange($event)" [formControlName]="swissField.options.key!">
          <mat-option *ngFor="let opt of swissField.options.optionsNeu" [value]="opt.key">
            {{ opt.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <label *ngSwitchCase="'radio'">{{ swissField.options.label }}</label>
	    <mat-radio-group *ngSwitchCase="'radio'" [formControlName]="swissField.options.key!" class="example-radio-group">
        <mat-radio-button *ngFor="let opt of swissField.options.optionsNeu" [value]="opt.key" class="example-radio-button">
          {{ opt.value }}
        </mat-radio-button>
      </mat-radio-group>
    </ng-container>

      <!-- For existing Entities -->
    <ng-container *ngIf="!swissField.isNewEntity">
      <div *ngSwitchCase="'dropdown'" style="display: flex; flex-direction: row;">
        <mat-form-field [style.margin]="ignoreStyling() ? '' : swissField!.options.styleMargin" [style.width]="ignoreStyling() ? '' : swissField!.options.styleWidth" class="no-padding">
          <mat-label>{{ swissField.options.label ? swissField.options.label : '' }}</mat-label>
          <ng-container *ngIf="swissField.options.readOnly">
	          <input [formControlName]="swissField.options.key!" [readonly]="true" [value]="swissField.options.value!" matInput>
          </ng-container>
	        <mat-select #select (selectionChange)="dropdownSelectionChange($event)" *ngIf="!swissField.options.readOnly"
                        [formControlName]="swissField.options.key!" [value]="swissField.options.value">
            <mat-option *ngIf="!swissField.options.required" [value]="null"></mat-option>
            <mat-option *ngFor="let opt of swissField.options.optionsBestehend" [value]="opt.key">
              {{ opt.value }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div (click)="select.writeValue(null)" *ngIf="!swissField.options.required" class="mat-form-field-infix" style="display: flex; align-items: center;">
          <span style="padding: 0 4px; font-size: 20px; cursor: pointer;">X</span>
        </div>
      </div>

      <label *ngSwitchCase="'radio'" class="example-radio-label">{{ swissField.options.label }}</label>
	    <mat-radio-group *ngSwitchCase="'radio'" [formControlName]="swissField.options.key!" class="example-radio-group">
        <mat-radio-button *ngFor="let opt of swissField.options.optionsBestehend" [value]="opt.key" class="example-radio-button">
          {{ opt.value }}
        </mat-radio-button>
      </mat-radio-group>
    </ng-container>
  </ng-container>
</span>
